export class MotivoArquivamento {
    codigoMotivo: number;
    descricaoMotivo: string;

    constructor(response: any) {
        this.codigoMotivo = response.codigoMotivo;
        this.descricaoMotivo = response.descricaoMotivo;
    }
}